import React from 'react'
import { Card, Col, Row, Collapse, Spin } from 'antd'
import DelayHideLoading from 'components/DelayHideLoading'
import styles from './index.scss'
import category171 from 'assets/images/home-category-171.svg'
import category173 from 'assets/images/home-category-173.svg'
import category178 from 'assets/images/home-category-178.svg'
import category185 from 'assets/images/home-category-185.svg'
import category2396 from 'assets/images/home-category-2396.svg'
import category2570 from 'assets/images/home-category-2570.png'

const Panel = Collapse.Panel

export type categoryItem = {
  category_id: number
  category_name: number
  id: number
  child: categoryItem[]
  isCategory?: boolean
}

export interface IVideoNavigationProps {
  data: categoryItem[]
  handler: any
  onClick: any
}

const categoryImgs = {
  171: category171,
  173: category173,
  178: category178,
  185: category185,
  2396: category2396,
  2570: category2570,
}

class VideoNavigation extends React.Component<IVideoNavigationProps, any> {
  handleCategoryChange(e, item, c0, c1, c2) {
    const isActive = e.length > 0
    if (isActive) {
      this.props.handler(item, c0, c1, c2)
    }
  }

  handleClick(id, type, content) {
    this.props.onClick(id, type, content)
  }
  renderNav = videoData => {
    return (
      <Row gutter={13} justify="center" type="flex">
        {videoData.map((item, c0Index) => (
          <Col
            key={item.category_name}
            span={Math.floor(24 / videoData.length)}
            style={{
              width: `${Math.ceil(100 / videoData.length)}`,
            }}
          >
            <img
              className={styles.headImg}
              src={categoryImgs[item.category_id]}
            />
            <Card bordered={false}>
              {item.child &&
                item.child.map((c1, c1Index) => (
                  <div key={c1.category_name}>
                    <h4 className={styles.MainCategoryName}>
                      {c1.category_name}
                    </h4>
                    {c1.child &&
                      c1.child.map((c2, c2Index) => (
                        <Collapse
                          key={c2Index}
                          onChange={e =>
                            this.handleCategoryChange(
                              e,
                              c2,
                              c0Index,
                              c1Index,
                              c2Index,
                            )
                          }
                        >
                          <Panel
                            header={
                              <h5 className={styles.subCategoryName}>
                                <span>{c2.category_name}</span>
                                <span className={styles.menuTag}>
                                  {c2.remark}
                                </span>
                              </h5>
                            }
                            key={c2Index.toString()}
                            forceRender={false}
                          >
                            {c2.child && c2.child.length > 0 ? (
                              c2.child.map((c3, i) => (
                                <div className={styles.unitCategory} key={i}>
                                  <div className={styles.unitCategoryName}>
                                    {c3.category_name}
                                  </div>
                                  <ul className={styles.unitCategoryItem}>
                                    {c3.child && c3.child.length > 0 ? (
                                      c3.child.map(c4 => {
                                        return c4.isCategory ? (
                                          <li className={styles.itemType}>
                                            {c4.title}
                                          </li>
                                        ) : (
                                          <li
                                            className={styles.itemName}
                                            key={c4.id}
                                            onClick={() =>
                                              this.handleClick(
                                                c4.id,
                                                c4.type,
                                                c4.content,
                                              )
                                            }
                                          >
                                            <a
                                              href="javascript:void(0)"
                                              title={c4.title}
                                            >
                                              {c4.title}
                                            </a>
                                          </li>
                                        )
                                      })
                                    ) : (
                                      <li className={styles.empty}>
                                        <DelayHideLoading />
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              ))
                            ) : (
                              <div className={styles.empty}>
                                <DelayHideLoading />
                              </div>
                            )}
                          </Panel>
                        </Collapse>
                      ))}
                  </div>
                ))}
            </Card>
          </Col>
        ))}
      </Row>
    )
  }

  renderLoading = () => {
    return (
      <Spin
        tip="加载目录中..."
        size="large"
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translateX(-50%) translateY(-50%)',
        }}
      />
    )
  }

  render() {
    const { data: videoData } = this.props
    return (
      <div className={styles.videoNavigation}>
        {videoData.length > 0
          ? this.renderNav(videoData)
          : this.renderLoading()}
      </div>
    )
  }
}

export default VideoNavigation
